// extracted by mini-css-extract-plugin
export default {"movieCard":"Card_movieCard__CLttT","imgCard":"Card_imgCard__oG6nC"};